import { SettlementStatusEnum } from "@saleor/types/globalTypes";

import { otherAdjustmentRemarksCharacterLimit } from "../../components/FinanceAdjustDialog";

export const handleBulkUpdate = (
  type: SettlementStatusEnum,
  listElements,
  BulkUpdateSettlementStatus
) => {
  switch (type) {
    case SettlementStatusEnum.FOR_PAYMENT:
      BulkUpdateSettlementStatus({
        variables: {
          ids: listElements,
          settlementStatus: SettlementStatusEnum.FOR_PAYMENT
        }
      });
      break;
    case SettlementStatusEnum.EXCLUDED:
      BulkUpdateSettlementStatus({
        variables: {
          ids: listElements,
          settlementStatus: SettlementStatusEnum.EXCLUDED
        }
      });
      break;
    case SettlementStatusEnum.REOPENED:
      BulkUpdateSettlementStatus({
        variables: {
          ids: listElements,
          settlementStatus: SettlementStatusEnum.REOPENED
        }
      });
      break;
    default:
      break;
  }
};

export const restrictInput = (name, value) => {
  const currencyExp = /^([-]?(\d*|\d+\.)\d{0,2}|)$/;

  switch (name) {
    case "paymentFeeAdjustment":
      if (value.match(currencyExp)) {
        return true;
      }
      return false;
    case "deliveryFeeAdjustment":
      if (value.match(currencyExp)) {
        return true;
      }
      return false;
    case "penalties":
      if (value.match(currencyExp)) {
        return true;
      }
      return false;
    case "otherAdjustment":
      if (value.match(currencyExp)) {
        return true;
      }
      return false;
    case "otherAdjustmentRemarks":
      if (value.length <= otherAdjustmentRemarksCharacterLimit) {
        return true;
      }
      return false;
    default:
      return false;
  }
};
